import type { MaybeRef } from '@vueuse/core';
import { get, useIntervalFn } from '@vueuse/core';
import { useIdle } from '@/composable/useIdle';
import { isWsConnected } from '@/core/oddsApi/apollo';
import { useLiveScore } from '@/core/oddsApi/composable/useLiveScore';

export function useLiveScoreEuro(eventId: MaybeRef<number>, isEnabled: MaybeRef<boolean> = true) {
    const { liveScore, refetch } = useLiveScore(eventId, isEnabled);

    const isValidEventId = () => get(eventId) > 0;

    useIntervalFn(() => {
        if (!get(isEnabled) || !isValidEventId() || isWsConnected.value) return;
        refetch();
    }, (30 * 1000));

    // Automatically recover from idle state with a force refresh
    // This is to prevent the user from losing data when they are idle
    const { onActive } = useIdle(60 * 1000);
    onActive(() => {
        if (!get(isEnabled) || !isValidEventId()) return;
        // eslint-disable-next-line no-console
        refetch();
    });

    return {
        liveScore,
    };
}
